"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVolatilityCMSKey = void 0;
const getVolatilityCMSKey = (value) => {
    const volatilityLablesMap = {
        'very-low': 3,
        'low': 6,
        'medium': 9,
        'medium-high': 12,
        'high': 15,
        'very-high': 18,
    };
    for (const [cmsKey, volatilityValue] of Object.entries(volatilityLablesMap)) {
        if (value <= volatilityValue) {
            return `volatility.${cmsKey}`;
        }
    }
    return 'volatility.extreme';
};
exports.getVolatilityCMSKey = getVolatilityCMSKey;
